const excludeRoutes = (location: Location) => {
    const pathname = location.pathname.toLowerCase();
    const exclude = ["/silent-renew", "/login"];

    for (const key in exclude) {
        if (!exclude.hasOwnProperty(key)) {
            continue;
        }

        const excludePathname = exclude[key];

        if (excludePathname === pathname) {
            return true;
        }
    }

    return false;
}

export default excludeRoutes;